import { push } from 'react-router-redux';
import * as actions from './actions';

/*
  Select a segment on the map.
*/
const selectSegment = id => dispatch => {
  // We could check here if the segments' from and to points match, so we're sure we're creating a route
  // However, I'm not sure if I'm meant to pass a whole segment object here.
  dispatch(actions.selectSegment(id));
};

const deselectSegment = id => (dispatch, getState) => {
  const { routeCreation: { selectedSegments } } = getState();

  if (!selectedSegments || !selectedSegments.includes(id)) {
    throw new Error(
      `Can not deselect id ${id} because the current selection is ${selectedSegments}`
    );
  }

  dispatch(actions.deselectSegment(id));
};

const finishCreateRoute = () => dispatch => {
  dispatch(actions.clearCreateRoute());
  dispatch(push('/map/live'));
};

export default {
  selectSegment,
  deselectSegment,
  setCreatedRouteId: actions.setCreatedRouteId,
  finishCreateRoute,
  clearCreateRoute: actions.clearCreateRoute,
};



// WEBPACK FOOTER //
// ./src/state/ducks/routeCreation/operations.js